import type {
  Activity,
  ActivityType,
  AcknowledgementPayloadDTO,
  AcknowledgementResponseDTO,
  ConsentPayloadDTO,
  ConsentResponseDTO,
  PatientProfile,
  ProfileUpdatePayload,
  UUID,
} from "@/core/types";
import type { ApiParams, AptiRequestConfig } from "@/lib/types/api";
import { httpAuth } from "@/utils/axios";
import type { InsuranceListResponse } from "@/features/insurance/types";

export const patientRequestsTyped = {
  append_acknowledgement: function ({
    data,
    params,
  }: {
    data: AcknowledgementPayloadDTO;
    params?: ApiParams;
  }) {
    const config = {
      data,
      method: "POST",
      params,
      url: "/v1/patient/append_acknowledgement",
    } satisfies AptiRequestConfig;

    return httpAuth(config) as unknown as Promise<AcknowledgementResponseDTO>;
  },

  append_patient_consent: function ({
    data,
    params,
  }: {
    data: ConsentPayloadDTO;
    params?: Record<string, unknown>;
  }) {
    const config = {
      data,
      method: "POST",
      params,
      preventAllErrorToast: true,
      url: "/v1/patient/append_consent",
    } satisfies AptiRequestConfig;

    return httpAuth(config) as unknown as Promise<ConsentResponseDTO>;
  },

  get_activity_list: function ({ params, type }: { params?: ApiParams; type: ActivityType }) {
    const config = {
      method: "POST",
      params,
      url: `/v1/patient/activity?type=${type}`,
    } satisfies AptiRequestConfig;

    return httpAuth(config) as unknown as Promise<Activity[]>;
  },

  get_insurance_list: function ({
    params,
  }: {
    params?: ApiParams;
  } = {}): Promise<InsuranceListResponse> {
    const config = {
      method: "POST",
      params,
      url: "/v2/patient/insurance",
    } satisfies AptiRequestConfig;

    return httpAuth(config) as unknown as Promise<InsuranceListResponse>;
  },

  remove_from_wait_list: function ({
    params,
    patientId,
  }: {
    params?: ApiParams;
    patientId: UUID;
  }): Promise<void> {
    const config = {
      method: "POST",
      params,
      url: `/v1/patient/wait_list?method=remove&patient_username=${patientId}`,
    } satisfies AptiRequestConfig;

    return httpAuth(config) as unknown as Promise<void>;
  },

  update_profile: function ({ data }: { data: ProfileUpdatePayload }) {
    const config = {
      data,
      method: "POST",
      url: "/v1/patient/update_profile",
    } satisfies AptiRequestConfig;

    return httpAuth(config) as unknown as Promise<PatientProfile>;
  },
};
